<template>
  <div class="pdfDialog">
    <div class="pdf" v-show="fileType == 'pdf'">
      <p class="arrow">
        <!-- 前のページ -->
        <span @click="changePdfPage(0)" class="currentPage" :class="{ grey: currentPage == 1 }">{{$t('COMMON.BTN_PREVIOUS_PAGE')}}&nbsp;&nbsp;</span>
        <span style="color: #c2c2c2;">{{ currentPage }} / {{ pageCount }}</span>
        <!-- 次のページ -->
        <span @click="changePdfPage(1)" class="currentPage" :class="{ grey: currentPage == pageCount }">&nbsp;&nbsp;{{$t('COMMON.BTN_NEXT_PAGE')}}</span>&nbsp;&nbsp;&nbsp;&nbsp;<el-button icon="el-icon-download" @click="download()" type="primary" size="mini"></el-button>
        <span style="float :right;padding-right:20px;font-size: 20px;color: #c2c2c2;cursor: pointer;" @click="close"><i class="el-icon-close"></i></span>
      </p>
      <pdf :src="src.url" :page="currentPage" @num-pages="pageCount = $event" @page-loaded="currentPage = $event" @loaded="loadPdfHandler"></pdf>
    </div>
  </div>
</template>

<script>
import pdf from "vue-pdf";
export default {
  name: "attachPreview",
  components: { pdf: pdf },
  props: ["src"],
  data() {
    return {
      filesProps: {
        label: "originName"
      },
      currentPage: 0, // pdf文件页码
      pageCount: 0, // pdf文件总页数
      fileType: "pdf",// 文件类型
    };
  },
  created() {

  },
  methods: {
    // 改变PDF页码,val传过来区分上一页下一页的值,0上一页,1下一页
    changePdfPage(val) {
      if (val === 0 && this.currentPage > 1) {
        this.currentPage--;
      }
      if (val === 1 && this.currentPage < this.pageCount) {
        this.currentPage++;
      }
    },
    // pdf加载时
    loadPdfHandler() {
      this.currentPage = 1; // 加载的时候先加载第一页
    },

    close() {
      this.$emit('pdfClose')
    },

    //附件下载
    download() {
      let url = this.src.url
      let link = document.createElement('a');
      link.style.display = 'none';
      link.href = url;
      link.setAttribute('download', this.src.name);
      document.body.appendChild(link);
      link.click(link);
      // 下载完成移除元素
      document.body.removeChild(link);
      // 释放掉blob对象
      //window.URL.revokeObjectURL(url);
    }
  }
};
</script>

<style >
.pdfDialog .el-dialog__wrapper {
  background-color: rgb(114, 114, 114);
}
.currentPage {
  cursor: pointer;
  color: #c2c2c2;
}

.currentPage:hover {
  color: #2761ff;
}

.arrow {
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 2;
  width: 100%;
  background-color: #191919;
  padding: 12px 0;
  margin: 0;
  text-align: center;
}

.el-dialog__body {
  color: #606266;
  font-size: 14px;
  padding: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/page/pdf.vue